var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "newQianniuExamex" } }, [
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "row",
          "align-items": "center",
          "margin-bottom": "10px",
          cursor: "pointer",
          width: "100px"
        },
        on: { click: _vm.goBack }
      },
      [
        _c("i", { staticClass: "el-icon-arrow-left" }),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-left": "10px" } }, [_vm._v("返回")])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "el-tabs el-tabs--left" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs__content" }, [
        _c(
          "div",
          { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-first" } },
              [
                _c(
                  "div",
                  { staticClass: "con-left", staticStyle: { padding: "0" } },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isShowQnIcon ||
                              _vm.isShowLoginImg ||
                              _vm.isShowRnd,
                            expression:
                              "isShowQnIcon || isShowLoginImg || isShowRnd"
                          }
                        ],
                        staticClass: "qnbox",
                        staticStyle: { "user-select": "none" }
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.mouseFocus,
                              expression: "!mouseFocus"
                            }
                          ],
                          staticClass: "qnbg",
                          attrs: {
                            src: require("@/assets/images/newestqianniu/qnbg1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.mouseFocus,
                              expression: "mouseFocus"
                            }
                          ],
                          staticClass: "qnbg",
                          attrs: {
                            src: require("@/assets/images/newestqianniu/qnbg2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "qnicon01",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocus = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocus = false
                            },
                            click: _vm.showLoginImg
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowLoginImg,
                                expression: "isShowLoginImg"
                              }
                            ],
                            staticClass: "login",
                            staticStyle: { "user-select": "none" }
                          },
                          [
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isSaveAP,
                                  expression: "isSaveAP"
                                }
                              ],
                              staticClass: "homeImg",
                              attrs: {
                                src: require("@/assets/images/newestqianniu/login3.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isSaveAP && _vm.mouseFocusSaveAP,
                                  expression: "!isSaveAP && mouseFocusSaveAP"
                                }
                              ],
                              staticClass: "homeImg",
                              attrs: {
                                src: require("@/assets/images/newestqianniu/login2.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isSaveAP && !_vm.mouseFocusSaveAP,
                                  expression: "!isSaveAP && !mouseFocusSaveAP"
                                }
                              ],
                              staticClass: "homeImg",
                              attrs: {
                                src: require("@/assets/images/newestqianniu/login1.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.name,
                                  expression: "name",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "name",
                              attrs: {
                                type: "text",
                                placeholder: "请输入账号"
                              },
                              domProps: { value: _vm.name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.name = $event.target.value.trim()
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.password,
                                  expression: "password",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "password",
                              attrs: {
                                type: "password",
                                autocomplete: "new-password",
                                placeholder: "请输入密码"
                              },
                              domProps: { value: _vm.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.password = $event.target.value.trim()
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "hovertag",
                              on: {
                                mouseenter: function($event) {
                                  _vm.mouseFocusSaveAP = true
                                },
                                mouseleave: function($event) {
                                  _vm.mouseFocusSaveAP = false
                                },
                                click: function($event) {
                                  _vm.isSaveAP = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "logIn",
                              on: { click: _vm.loginIn }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isShowRnd,
                                expression: "isShowRnd"
                              }
                            ],
                            staticClass: "loginrnd"
                          },
                          [
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showRnd,
                                  expression: "showRnd"
                                }
                              ],
                              staticClass: "rndImg",
                              attrs: {
                                src: require("@/assets/images/newestqianniu/loginrnd3.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.showRnd && _vm.mouseFocusRnd,
                                  expression: "!showRnd && mouseFocusRnd"
                                }
                              ],
                              staticClass: "rndImg",
                              attrs: {
                                src: require("@/assets/images/newestqianniu/loginrnd2.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.showRnd && !_vm.mouseFocusRnd,
                                  expression: "!showRnd && !mouseFocusRnd"
                                }
                              ],
                              staticClass: "rndImg",
                              attrs: {
                                src: require("@/assets/images/newestqianniu/loginrnd1.png")
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "sendRnd",
                              on: {
                                mouseenter: function($event) {
                                  _vm.mouseFocusRnd = true
                                },
                                mouseleave: function($event) {
                                  _vm.mouseFocusRnd = false
                                },
                                click: function($event) {
                                  _vm.showRnd = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.rnd,
                                  expression: "rnd",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "rnd",
                              attrs: {
                                type: "text",
                                placeholder: "短信验证码"
                              },
                              domProps: { value: _vm.rnd },
                              on: {
                                mouseenter: function($event) {
                                  _vm.mouseFocusRnd = true
                                },
                                mouseleave: function($event) {
                                  _vm.mouseFocusRnd = false
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.rnd = $event.target.value.trim()
                                },
                                blur: function($event) {
                                  return _vm.$forceUpdate()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "logInRnd",
                              on: { click: _vm.loginInRnd }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowQnIcon2,
                            expression: "isShowQnIcon2"
                          }
                        ],
                        staticClass: "qnbox"
                      },
                      [
                        _c("img", {
                          staticClass: "qnbg",
                          attrs: {
                            src: require("@/assets/images/newestqianniu/qnbg2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "qnicon02",
                          on: { dblclick: _vm.showLoginImg2 }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowLoginIndex,
                            expression: "isShowLoginIndex"
                          }
                        ],
                        staticClass: "jdbox"
                      },
                      [
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.mouseFocusJD,
                              expression: "mouseFocusJD"
                            }
                          ],
                          staticClass: "jdimg",
                          attrs: {
                            src: require("@/assets/images/newestqianniu/loginindex1.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.mouseFocusJD,
                              expression: "!mouseFocusJD"
                            }
                          ],
                          staticClass: "jdimg",
                          attrs: {
                            src: require("@/assets/images/newestqianniu/loginindex2.png")
                          }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "jdicon",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusJD = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusJD = false
                            },
                            click: _vm.enterJd
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShowLoginIndexTwo,
                            expression: "isShowLoginIndexTwo"
                          }
                        ],
                        staticClass: "indexbox"
                      },
                      [
                        _c("img", {
                          staticClass: "indeximg",
                          attrs: {
                            src: require("@/assets/images/newestqianniu/loginindex3.png")
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.isShowQnIcon || _vm.isShowQnIcon2
                      ? _c("p", [
                          _vm._v("请"),
                          _c("span", { staticClass: "red-span" }, [
                            _vm._v("登录")
                          ]),
                          _vm._v("千牛工作台，并进入"),
                          _c("span", { staticClass: "red-span" }, [
                            _vm._v("接待中心")
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginImg
                      ? [_vm._m(2), _vm._v(" "), _vm._m(3)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowRnd
                      ? [_vm.showRnd ? [_vm._m(4)] : [_vm._m(5)]]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isShowLoginIndex ? [_vm._m(6)] : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-first" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-second", 2, "second")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "second" },
            attrs: { id: "tab-second-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-second" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 1,
                          expression: "secondStep == 1"
                        }
                      ],
                      staticClass: "gqbox"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.gqstep == 1,
                            expression: "gqstep == 1"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnstatus1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.gqstep == 1,
                              expression: "gqstep == 1"
                            }
                          ],
                          staticClass: "gqbtn",
                          on: {
                            click: function($event) {
                              _vm.gqstep = 2
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.gqstep == 2 && _vm.mouseFocusZX,
                            expression: "gqstep == 2 && mouseFocusZX"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnstatus3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.gqstep == 2 && !_vm.mouseFocusZX,
                            expression: "gqstep == 2 && !mouseFocusZX"
                          }
                        ],
                        staticClass: "gqimg",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnstatus2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.gqstep == 2,
                              expression: "gqstep == 2"
                            }
                          ],
                          staticClass: "gqclick",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusZX = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusZX = false
                            },
                            click: function($event) {
                              _vm.secondStep = 2
                            }
                          }
                        },
                        [_vm._v(" ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 2,
                          expression: "secondStep == 2"
                        }
                      ],
                      staticClass: "wgqbox"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 1,
                            expression: "wgqstep == 1"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnstatus4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.wgqstep == 1,
                              expression: "wgqstep == 1"
                            }
                          ],
                          staticClass: "gqbtn",
                          on: {
                            click: function($event) {
                              _vm.wgqstep = 2
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 2 && _vm.mouseFocusGQ,
                            expression: "wgqstep == 2 && mouseFocusGQ"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnstatus6.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 2 && !_vm.mouseFocusGQ,
                            expression: "wgqstep == 2 && !mouseFocusGQ"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnstatus5.png")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.wgqstep == 2,
                              expression: "wgqstep == 2"
                            }
                          ],
                          staticClass: "gqclick",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusGQ = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusGQ = false
                            },
                            click: function($event) {
                              _vm.wgqstep = 3
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.wgqstep == 3,
                            expression: "wgqstep == 3"
                          }
                        ],
                        staticClass: "wgqimg",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnstatus7.png")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.wgqstep == 3,
                              expression: "wgqstep == 3"
                            }
                          ],
                          staticClass: "cgqbtn",
                          on: {
                            click: function($event) {
                              _vm.secondStep = 3
                            }
                          }
                        },
                        [_vm._v(" ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 3,
                          expression: "secondStep == 3"
                        }
                      ],
                      staticClass: "second-step3"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 1,
                            expression: "secondStepStep == 1"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnstatus1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 1,
                            expression: "secondStepStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.secondStepStep = 2
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 2 && !_vm.mouseFocusDdsc,
                            expression: "secondStepStep == 2 && !mouseFocusDdsc"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnsort1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 2 && _vm.mouseFocusDdsc,
                            expression: "secondStepStep == 2 && mouseFocusDdsc"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnsort2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 2,
                              expression: "secondStepStep == 2"
                            }
                          ],
                          staticClass: "btn2",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusDdsc = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusDdsc = false
                            },
                            click: function($event) {
                              _vm.secondStep = 4
                            }
                          }
                        },
                        [_vm._v(" ")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.secondStep == 4,
                          expression: "secondStep == 4"
                        }
                      ],
                      staticClass: "second-step3"
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 2 && !_vm.mouseFocusSet,
                            expression: "secondStepStep == 2 && !mouseFocusSet"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnsort3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 2 && _vm.mouseFocusSet,
                            expression: "secondStepStep == 2 && mouseFocusSet"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnset1.png")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 2,
                              expression: "secondStepStep == 2"
                            }
                          ],
                          staticClass: "btn3",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusSet = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusSet = false
                            },
                            click: function($event) {
                              _vm.secondStepStep = 3
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 3 && !_vm.mouseFocusSetInfo,
                            expression:
                              "secondStepStep == 3 && !mouseFocusSetInfo"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnset2.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 3 && _vm.mouseFocusSetInfo,
                            expression:
                              "secondStepStep == 3 && mouseFocusSetInfo"
                          }
                        ],
                        staticClass: "img-base",
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnset3.png")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 3,
                              expression: "secondStepStep == 3"
                            }
                          ],
                          staticClass: "btn4",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusSetInfo = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusSetInfo = false
                            },
                            click: function($event) {
                              _vm.secondStepStep = 4
                            }
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 4 &&
                              !_vm.mouseFocusSetInfoDetail,
                            expression:
                              "secondStepStep == 4 && !mouseFocusSetInfoDetail"
                          }
                        ],
                        staticClass: "img-base",
                        staticStyle: { height: "681.5px" },
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnset4.png")
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.secondStepStep == 4 &&
                              _vm.mouseFocusSetInfoDetail,
                            expression:
                              "secondStepStep == 4 && mouseFocusSetInfoDetail"
                          }
                        ],
                        staticClass: "img-base",
                        staticStyle: { height: "681.5px" },
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnset5.png")
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.secondStepStep == 4,
                              expression: "secondStepStep == 4"
                            }
                          ],
                          staticClass: "btn5",
                          on: {
                            mouseenter: function($event) {
                              _vm.mouseFocusSetInfoDetail = true
                            },
                            mouseleave: function($event) {
                              _vm.mouseFocusSetInfoDetail = false
                            },
                            click: _vm.showGqImgClick
                          }
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.secondStepStep == 5,
                            expression: "secondStepStep == 5"
                          }
                        ],
                        staticClass: "img-base",
                        staticStyle: { height: "681.5px" },
                        attrs: {
                          src: require("@/assets/images/newestqianniu/qnset6.png")
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(7),
                  _vm._v(" "),
                  _vm.secondStep == 1
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("在线")]
                        )
                      ])
                    : _vm.secondStep == 2
                    ? _c("p", [
                        _vm._v("请将状态切换为"),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("挂起")]
                        )
                      ])
                    : _vm.secondStep == 3
                    ? _c("p", [
                        _vm._v("请将接待排序设置为："),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "red", "font-weight": "bold" }
                          },
                          [_vm._v("按客户等待时长排序")]
                        )
                      ])
                    : _vm.secondStep == 4
                    ? _c("p", [
                        _vm._v("请确认"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("店铺分流")
                        ]),
                        _vm._v("和"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("账号分流")
                        ]),
                        _vm._v("是否开启")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-second" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-third", 3, "third")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "third" },
            attrs: { id: "tab-third-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-third" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "jdgkbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 1,
                          expression: "kjdyStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy1.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 1,
                            expression: "kjdyStep == 1"
                          }
                        ],
                        staticClass: "search-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "search",
                          attrs: { placeholder: "联系人,订单号，聊天记录" },
                          on: { input: _vm.kjdySearchChange },
                          model: {
                            value: _vm.kjdySearch,
                            callback: function($$v) {
                              _vm.kjdySearch = $$v
                            },
                            expression: "kjdySearch"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 2,
                          expression: "kjdyStep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy2.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 2,
                            expression: "kjdyStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 3 && !_vm.mouseFocusKJDY,
                          expression: "kjdyStep == 3 && !mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy3.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 3 && _vm.mouseFocusKJDY,
                          expression: "kjdyStep == 3 && mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy4.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 3,
                            expression: "kjdyStep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusKJDY = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusKJDY = false
                          },
                          click: function($event) {
                            _vm.kjdyStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 4,
                          expression: "kjdyStep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy5.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 4,
                            expression: "kjdyStep == 4"
                          }
                        ],
                        staticClass: "btn4",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _vm.kjdyStep == 5
                      ? _c("img", {
                          staticClass: "img-base",
                          attrs: {
                            src: require("@/assets/images/newestqianniu/kjdy6.png")
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 5,
                            expression: "kjdyStep == 5"
                          }
                        ],
                        staticClass: "btn5",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 6 && !_vm.mouseFocusFZ,
                          expression: "kjdyStep == 6 && !mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy7.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 6 && _vm.mouseFocusFZ,
                          expression: "kjdyStep == 6 && mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy8.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 6,
                            expression: "kjdyStep == 6"
                          }
                        ],
                        staticClass: "btn6",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZ = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZ = false
                          },
                          click: function($event) {
                            _vm.kjdyStep = 7
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 7 && !_vm.mouseFocusFZI,
                          expression: "kjdyStep == 7 && !mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy9.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 7 && _vm.mouseFocusFZI,
                          expression: "kjdyStep == 7 && mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy10.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 7,
                            expression: "kjdyStep == 7"
                          }
                        ],
                        staticClass: "kjdyfz-c",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZI = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZI = false
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjfz-input",
                          attrs: { placeholder: "请输入分组" },
                          model: {
                            value: _vm.kjdyfz,
                            callback: function($$v) {
                              _vm.kjdyfz = $$v
                            },
                            expression: "kjdyfz"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 7,
                          expression: "kjdyStep == 7"
                        }
                      ],
                      staticClass: "btn7",
                      on: { click: _vm.kjdyfzConfirm }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 8,
                          expression: "kjdyStep == 8"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy11.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.kjdyStep == 5 ||
                              _vm.kjdyStep == 6 ||
                              _vm.kjdyStep == 8,
                            expression:
                              "kjdyStep == 5 || kjdyStep == 6 || kjdyStep == 8"
                          }
                        ],
                        staticClass: "kjbm-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjbm-input",
                          model: {
                            value: _vm.kjdybm,
                            callback: function($$v) {
                              _vm.kjdybm = $$v
                            },
                            expression: "kjdybm"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.kjdyStep == 5 ||
                              _vm.kjdyStep == 6 ||
                              _vm.kjdyStep == 8,
                            expression:
                              "kjdyStep == 5 || kjdyStep == 6 || kjdyStep == 8"
                          }
                        ],
                        staticClass: "kjdy-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjdy-input",
                          attrs: {
                            placeholder: "请输入快捷短语",
                            type: "textarea"
                          },
                          model: {
                            value: _vm.kjdynr,
                            callback: function($$v) {
                              _vm.kjdynr = $$v
                            },
                            expression: "kjdynr"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 8,
                            expression: "kjdyStep == 8"
                          }
                        ],
                        staticClass: "btn8",
                        on: { click: _vm.kjdyConfirm }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 9,
                          expression: "kjdyStep == 9"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy12.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 9,
                            expression: "kjdyStep == 9"
                          }
                        ],
                        staticClass: "btn9",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 10
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 10,
                          expression: "kjdyStep == 10"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy13.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      ref: "fileInput",
                      staticClass: "btn-file",
                      attrs: { type: "file" },
                      on: {
                        change: function($event) {
                          return _vm.tirggerFile($event)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 11,
                          expression: "kjdyStep == 11"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy14.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 11,
                            expression: "kjdyStep == 11"
                          }
                        ],
                        staticClass: "btn11",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 12
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 12 && !_vm.mouseFocusKJDY,
                          expression: "kjdyStep == 12 && !mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy15.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 12 && _vm.mouseFocusKJDY,
                          expression: "kjdyStep == 12 && mouseFocusKJDY"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy16.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 12,
                            expression: "kjdyStep == 12"
                          }
                        ],
                        staticClass: "btn12",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusKJDY = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusKJDY = false
                          },
                          click: function($event) {
                            _vm.kjdyStep = 13
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 13,
                          expression: "kjdyStep == 13"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy17.png")
                      }
                    }),
                    _vm._v(" "),
                    _vm.kjdyStep == 13
                      ? _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "btn133",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              _vm.kjdyStep = 14
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 13,
                            expression: "kjdyStep == 13"
                          }
                        ],
                        staticClass: "btn13",
                        on: {
                          click: function($event) {
                            _vm.kjdyStep = 14
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 14,
                          expression: "kjdyStep == 14"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy18.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 14,
                            expression: "kjdyStep == 14"
                          }
                        ],
                        staticClass: "kjdyfs-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjdyfs-input",
                          attrs: { type: "textarea" },
                          on: { input: _vm.kjdyfsChange },
                          model: {
                            value: _vm.kjdyfs,
                            callback: function($$v) {
                              _vm.kjdyfs = $$v
                            },
                            expression: "kjdyfs"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 15,
                          expression: "kjdyStep == 15"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy19.png")
                      }
                    }),
                    _vm._v(" "),
                    _vm.kjdyStep == 15
                      ? _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          staticClass: "btn155",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.enterSelect.apply(null, arguments)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 15,
                            expression: "kjdyStep == 15"
                          }
                        ],
                        staticClass: "btn15",
                        on: { click: _vm.enterSelect }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 16,
                          expression: "kjdyStep == 16"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy20.png")
                      }
                    }),
                    _vm._v(" "),
                    _vm.kjdyStep == 16
                      ? _c("input", {
                          directives: [
                            {
                              name: "focus",
                              rawName: "v-focus",
                              value: true,
                              expression: "true"
                            }
                          ],
                          ref: "sixInput",
                          staticClass: "btn16",
                          attrs: { type: "text" },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.finishThird.apply(null, arguments)
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.kjdyStep == 16,
                            expression: "kjdyStep == 16"
                          }
                        ],
                        staticClass: "btn13",
                        on: { click: _vm.finishThird }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.kjdyStep == 17,
                          expression: "kjdyStep == 17"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/kjdy21.png")
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "con-right" },
                  [
                    _vm._m(8),
                    _vm._v(" "),
                    _vm.kjdyStep == 1 || _vm.kjdyStep == 2
                      ? _c("p", [
                          _vm._v("请搜索登录账号"),
                          _c("br"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("淘金云客服:小淘")]
                          ),
                          _vm._v("打开会话窗口")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 3
                      ? _c("p", [
                          _vm._v("请"),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold"
                              }
                            },
                            [_vm._v("打开快捷短语")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 4 ||
                    _vm.kjdyStep == 5 ||
                    _vm.kjdyStep == 6 ||
                    _vm.kjdyStep == 7 ||
                    _vm.kjdyStep == 8
                      ? [
                          _vm._m(9),
                          _vm._v(" "),
                          _vm._m(10),
                          _vm._v(" "),
                          _vm._m(11)
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 9 ||
                    _vm.kjdyStep == 10 ||
                    _vm.kjdyStep == 11
                      ? [
                          _vm._m(12),
                          _vm._v(" "),
                          _c("p", [
                            _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                              _vm._v("点击下载“快捷短语.csv”")
                            ])
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 12 || _vm.kjdyStep == 13
                      ? [_vm._m(13)]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.kjdyStep == 14 ||
                    _vm.kjdyStep == 15 ||
                    _vm.kjdyStep == 16 ||
                    _vm.kjdyStep == 17
                      ? [_vm._m(14)]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-third" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-four", 4, "four")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "four" },
            attrs: { id: "tab-four-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-four" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "cygnbox" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 1,
                          expression: "cygnStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/cygn1.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 1,
                            expression: "cygnStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          mouseenter: function($event) {
                            _vm.cygnStep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 2 && !_vm.mouseFocusDdsc,
                          expression: "cygnStep == 2 && !mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/cygn2.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 2 && _vm.mouseFocusDdsc,
                          expression: "cygnStep == 2 && mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/cygn3.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 2,
                            expression: "cygnStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusDdsc = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDdsc = false
                          },
                          click: _vm.fourStepBystep
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 3,
                          expression: "cygnStep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/cygn4.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 4 && !_vm.mouseFocus,
                          expression: "cygnStep == 4 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/cygn5.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 4 && _vm.mouseFocus,
                          expression: "cygnStep == 4 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/cygn6.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 4,
                            expression: "cygnStep == 4"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.cygnStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 5,
                          expression: "cygnStep == 5"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/cygn7.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 5,
                            expression: "cygnStep == 5"
                          }
                        ],
                        staticClass: "btn5",
                        on: {
                          click: function($event) {
                            _vm.cygnStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 6,
                          expression: "cygnStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/cygn8.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 6,
                            expression: "cygnStep == 6"
                          }
                        ],
                        staticClass: "zfyy-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "zjyy-input",
                          attrs: { placeholder: "请输入转交原因" },
                          model: {
                            value: _vm.zjyy,
                            callback: function($$v) {
                              _vm.zjyy = $$v
                            },
                            expression: "zjyy"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.cygnStep == 6,
                            expression: "cygnStep == 6"
                          }
                        ],
                        staticClass: "btn6",
                        on: { click: _vm.sendZfyy }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.cygnStep == 7,
                          expression: "cygnStep == 7"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/cygn10.png")
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(15),
                  _vm._v(" "),
                  _vm.cygnStep == 1 || _vm.cygnStep == 2 || _vm.cygnStep == 3
                    ? _c("p", [
                        _vm._v("请给当前用户标记"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("黄色星星")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.cygnStep == 4 ||
                  _vm.cygnStep == 5 ||
                  _vm.cygnStep == 6 ||
                  _vm.cygnStep == 7
                    ? _c("p", [
                        _vm._v("请将当前用户"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("转发")
                        ]),
                        _vm._v("给"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("小金")
                        ]),
                        _vm._v("，转交原因填写"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("少件")
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-four" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-five", 5, "five")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "five" },
            attrs: { id: "tab-five-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-five" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zncj-top-box" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 1 && !_vm.mouseFocus,
                          expression: "zncjsstep == 1 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/tjsp1.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 1 && _vm.mouseFocus,
                          expression: "zncjsstep == 1 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/tjsp2.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjsstep == 1,
                            expression: "zncjsstep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.zncjsstep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 2 && !_vm.mouseFocus,
                          expression: "zncjsstep == 2 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/tjsp3.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 2 && _vm.mouseFocus,
                          expression: "zncjsstep == 2 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/tjsp4.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjsstep == 2,
                            expression: "zncjsstep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: _vm.tjspEnd
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjsstep == 3,
                          expression: "zncjsstep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/tjsp5.png")
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(16),
                  _vm._v(" "),
                  _vm.zncjsstep == 1 || _vm.zncjsstep == 2 || _vm.zncjsstep == 3
                    ? _c("p", [
                        _vm._v("请将"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("足迹")
                        ]),
                        _vm._v("中"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("符合客户需求")
                        ]),
                        _vm._v("的商品发送给客户")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-five" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six", 6, "six")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six" },
            attrs: { id: "tab-six-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "zncj-bottom-box" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 1,
                          expression: "zncjxstep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/fkzt1.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 1,
                            expression: "zncjxstep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 2,
                          expression: "zncjxstep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/fkzt2.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 2,
                            expression: "zncjxstep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 3,
                          expression: "zncjxstep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/fkzt3.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 3,
                            expression: "zncjxstep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: { click: _vm.sixStepByStep }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 4,
                          expression: "zncjxstep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/fkzt4.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 5,
                          expression: "zncjxstep == 5"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/ck1.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 5,
                            expression: "zncjxstep == 5"
                          }
                        ],
                        staticClass: "btn6",
                        on: { click: _vm.sixStepByStep2 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 6,
                          expression: "zncjxstep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/ck2.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 7,
                          expression: "zncjxstep == 7"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/xgyf1.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 7,
                            expression: "zncjxstep == 7"
                          }
                        ],
                        staticClass: "btn7",
                        on: {
                          click: function($event) {
                            _vm.showYfstep = true
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.zncjxstep == 7 &&
                            _vm.showYfstep &&
                            !_vm.mouseFocus,
                          expression:
                            "zncjxstep == 7 && showYfstep && !mouseFocus"
                        }
                      ],
                      staticClass: "img-yf",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/yfalert1.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.zncjxstep == 7 &&
                            _vm.showYfstep &&
                            _vm.mouseFocus,
                          expression:
                            "zncjxstep == 7 && showYfstep && mouseFocus"
                        }
                      ],
                      staticClass: "img-yf",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/yfalert2.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 7 && _vm.showYfstep,
                            expression: "zncjxstep == 7 && showYfstep"
                          }
                        ],
                        class: {
                          "yf-c": !_vm.mouseFocus,
                          "yf-c1": _vm.mouseFocus
                        },
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "yf-input",
                          attrs: { placeholder: "请输入邮费" },
                          model: {
                            value: _vm.yfamount,
                            callback: function($$v) {
                              _vm.yfamount = $$v
                            },
                            expression: "yfamount"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 7 && _vm.showYfstep,
                            expression: "zncjxstep == 7 && showYfstep"
                          }
                        ],
                        staticClass: "btn77",
                        on: { click: _vm.sixStepByStep3 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 8,
                          expression: "zncjxstep == 8"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/xgyf2.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 8,
                            expression: "zncjxstep == 8"
                          }
                        ],
                        staticClass: "btn8",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 9
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 9,
                          expression: "zncjxstep == 9"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/bz1.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 9,
                            expression: "zncjxstep == 9"
                          }
                        ],
                        staticClass: "btn9",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 10
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 10,
                          expression: "zncjxstep == 10"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/bz2.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 10 || _vm.zncjxstep == 9,
                            expression: "zncjxstep == 10 || zncjxstep == 9"
                          }
                        ],
                        staticClass: "kjdy-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "kjdy-input",
                          attrs: {
                            placeholder: "请输入备注内容",
                            type: "textarea"
                          },
                          model: {
                            value: _vm.bznr,
                            callback: function($$v) {
                              _vm.bznr = $$v
                            },
                            expression: "bznr"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 10,
                            expression: "zncjxstep == 10"
                          }
                        ],
                        staticClass: "btn10",
                        on: { click: _vm.sixStepByStep4 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 11,
                          expression: "zncjxstep == 11"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/bz3.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 12,
                          expression: "zncjxstep == 12"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/hddd1.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 12,
                            expression: "zncjxstep == 12"
                          }
                        ],
                        staticClass: "btn12",
                        on: { click: _vm.sixStepByStep5 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 13,
                          expression: "zncjxstep == 13"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/hddd2.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 14,
                          expression: "zncjxstep == 14"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/xgdh1.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 14,
                            expression: "zncjxstep == 14"
                          }
                        ],
                        staticClass: "btn14",
                        on: {
                          click: function($event) {
                            _vm.zncjxstep = 15
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 15,
                          expression: "zncjxstep == 15"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/xgdh2.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 15,
                            expression: "zncjxstep == 15"
                          }
                        ],
                        staticClass: "phone"
                      },
                      [_vm._v("13656565656")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 15,
                            expression: "zncjxstep == 15"
                          }
                        ],
                        staticClass: "phone-c",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "phone-input",
                          attrs: { placeholder: "请输入" },
                          model: {
                            value: _vm.phone,
                            callback: function($$v) {
                              _vm.phone = $$v
                            },
                            expression: "phone"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.zncjxstep == 15,
                            expression: "zncjxstep == 15"
                          }
                        ],
                        staticClass: "btn15",
                        on: { click: _vm.sixStepByStep6 }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.zncjxstep == 16,
                          expression: "zncjxstep == 16"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/xgdh1.png")
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(17),
                  _vm._v(" "),
                  _vm.zncjxstep == 1
                    ? _c("p", [
                        _vm._v("请将会话切换到"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("未付款客户")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 2
                    ? _c("p", [
                        _vm._v("请将会话切换到"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("已付款")
                        ]),
                        _vm._v("待发货"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("客户")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 3 || _vm.zncjxstep == 4
                    ? _c("p", [
                        _vm._v("请将会话切换到"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("已发货")
                        ]),
                        _vm._v("待收货"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("客户")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 5 || _vm.zncjxstep == 6
                    ? _c("p", [
                        _vm._v("请给客户发送"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("催付")
                        ]),
                        _vm._v("卡片")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 7
                    ? _c("p", [
                        _vm._v("请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("根据聊天内容，修改邮费")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 8 ||
                  _vm.zncjxstep == 9 ||
                  _vm.zncjxstep == 10 ||
                  _vm.zncjxstep == 11
                    ? _c("p", [
                        _vm._v("【假设商家要求"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("发顺丰")
                        ]),
                        _vm._v("的客户插"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("红色")
                        ]),
                        _vm._v("旗子】请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("添加订单备注，并勾选对应的彩旗。")
                        ]),
                        _c("br"),
                        _vm._v("备注内容为：发顺丰")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 12 || _vm.zncjxstep == 13
                    ? _c("p", [
                        _vm._v("请给客户发送"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("核对订单")
                        ]),
                        _vm._v("卡片")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.zncjxstep == 14 ||
                  _vm.zncjxstep == 15 ||
                  _vm.zncjxstep == 16
                    ? _c("p", [_vm._v("请修改客户电话")])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-six1", 7, "six1")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "six1" },
            attrs: { id: "tab-six1-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-six1" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-six1" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "qtcj-box" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 1,
                          expression: "qtcjStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/qtcj01.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 2,
                          expression: "qtcjStep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/qtcj02.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 1 || _vm.qtcjStep == 2,
                            expression: "qtcjStep == 1 || qtcjStep == 2"
                          }
                        ],
                        staticClass: "gfkf-c"
                      },
                      [
                        _c("el-input", {
                          staticClass: "gfkf-input",
                          attrs: { placeholder: "联系人、订单号、聊天记录" },
                          on: { input: _vm.onGfkfInput },
                          model: {
                            value: _vm.gfkf,
                            callback: function($$v) {
                              _vm.gfkf = $$v
                            },
                            expression: "gfkf"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 2,
                            expression: "qtcjStep == 2"
                          }
                        ],
                        staticClass: "gfkf-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 3,
                          expression: "qtcjStep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/qtcj03.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 3,
                            expression: "qtcjStep == 3"
                          }
                        ],
                        staticClass: "cjzx-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 4,
                          expression: "qtcjStep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/qtcj04.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 4,
                            expression: "qtcjStep == 4"
                          }
                        ],
                        staticClass: "fbtzj-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 5,
                          expression: "qtcjStep == 5"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/qtcj05.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 5,
                            expression: "qtcjStep == 5"
                          }
                        ],
                        staticClass: "lzykf-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 6,
                          expression: "qtcjStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/qtcj06.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 6,
                            expression: "qtcjStep == 6"
                          }
                        ],
                        staticClass: "closecjzx-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 7
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 7,
                          expression: "qtcjStep == 7"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/qtcj07.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 7,
                            expression: "qtcjStep == 7"
                          }
                        ],
                        staticClass: "fbt-btn",
                        on: {
                          click: function($event) {
                            _vm.qtcjStep = 8
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.qtcjStep == 8,
                          expression: "qtcjStep == 8"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/qtcj08.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.qtcjStep == 8,
                            expression: "qtcjStep == 8"
                          }
                        ],
                        staticClass: "ly-btn",
                        on: { click: _vm.six1StepEnd }
                      },
                      [_vm._v(" ")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(18),
                  _vm._v(" "),
                  _vm.qtcjStep == 1 || _vm.qtcjStep == 2
                    ? _c("p", [
                        _vm._v("请搜索"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("天猫官方客服")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 3
                    ? _c("p", [
                        _vm._v("请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("打开插件中心")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 4
                    ? _c("p", [
                        _vm._v("请添加"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("FBT咨询")
                        ]),
                        _vm._v("插件")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 5
                    ? _c("p", [
                        _vm._v("请添加"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("瓴羊客服")
                        ]),
                        _vm._v("插件")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 6
                    ? _c("p", [
                        _vm._v("请"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("关闭插件中心")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 7
                    ? _c("p", [
                        _vm._v("此页面右侧是"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("FBT插件")
                        ]),
                        _vm._v("功能区。"),
                        _c("br"),
                        _vm._v("请点击"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("订单备注")
                        ]),
                        _vm._v("按钮")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.qtcjStep == 8
                    ? _c("p", [
                        _vm._v("此页面右侧是"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("瓴羊插件")
                        ]),
                        _vm._v("功能区。"),
                        _c("br"),
                        _vm._v("请点击"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("物流详情")
                        ]),
                        _vm._v("按钮")
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-six1" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-seven", 8, "seven")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "seven" },
            attrs: { id: "tab-seven-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-seven" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "sh-cygn" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 1 && !_vm.mouseFocusDdsc,
                          expression: "shcygnStep == 1 && !mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/shcygn1.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 1 && _vm.mouseFocusDdsc,
                          expression: "shcygnStep == 1 && mouseFocusDdsc"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/shcygn2.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 1,
                            expression: "shcygnStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusDdsc = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusDdsc = false
                          },
                          click: function($event) {
                            _vm.shcygnStep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 2,
                          expression: "shcygnStep == 2"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: require("@/assets/images/newestqianniu/shcygn3.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 2,
                            expression: "shcygnStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.shcygnStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 3 && !_vm.mouseFocus,
                          expression: "shcygnStep == 3 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: require("@/assets/images/newestqianniu/shcygn4.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 3 && _vm.mouseFocus,
                          expression: "shcygnStep == 3 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: require("@/assets/images/newestqianniu/shcygn5.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 3,
                            expression: "shcygnStep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.shcygnStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 4 && !_vm.mouseFocusFZ,
                          expression: "shcygnStep == 4 && !mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: require("@/assets/images/newestqianniu/shcygn6.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 4 && _vm.mouseFocusFZ,
                          expression: "shcygnStep == 4 && mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: require("@/assets/images/newestqianniu/shcygn7.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 4,
                            expression: "shcygnStep == 4"
                          }
                        ],
                        staticClass: "btn4",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZ = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZ = false
                          },
                          click: function($event) {
                            _vm.shcygnStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 5 && !_vm.mouseFocusFZI,
                          expression: "shcygnStep == 5 && !mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: require("@/assets/images/newestqianniu/shcygn8.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 5 && _vm.mouseFocusFZI,
                          expression: "shcygnStep == 5 && mouseFocusFZI"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: require("@/assets/images/newestqianniu/shcygn9.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.shcygnStep == 5,
                            expression: "shcygnStep == 5"
                          }
                        ],
                        staticClass: "btn5",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZI = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZI = false
                          },
                          click: _vm.sevenStepEnd
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.shcygnStep == 6,
                          expression: "shcygnStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      staticStyle: { height: "681.5px" },
                      attrs: {
                        src: require("@/assets/images/newestqianniu/shcygn10.png")
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "con-right" }, [
                  _vm._m(19),
                  _vm._v(" "),
                  _vm.shcygnStep == 1
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("工作台")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shcygnStep == 2 || _vm.shcygnStep == 3
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("已卖出宝贝")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shcygnStep == 4
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("评价管理")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shcygnStep == 5 || _vm.shcygnStep == 6
                    ? _c("p", [
                        _vm._v("请进入"),
                        _c("span", { staticClass: "red-span" }, [
                          _vm._v("退款管理")
                        ])
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [_vm._v("实操通关，进入下一关吧")]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: {
                          click: function($event) {
                            return _vm.studyNext("#tab-eight", 9, "eight")
                          }
                        }
                      },
                      [_vm._v("GO，下一关")]
                    )
                  ])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "el-tab-pane",
            class: { mynone: _vm.tabCurrent !== "eight" },
            attrs: { id: "tab-eight-content" }
          },
          [
            _c(
              "div",
              { staticClass: "stoptip", attrs: { id: "stoptip-eight" } },
              [
                _c("div", { staticClass: "tip" }, [
                  _c("span", { staticClass: "el-icon-success" }),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "startstudy",
                        on: { click: _vm.startStudy }
                      },
                      [_vm._v("开始实操练习")]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content", attrs: { id: "content-eight" } },
              [
                _c("div", { staticClass: "con-left" }, [
                  _c("div", { staticClass: "tcqn" }, [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 1,
                          expression: "tcqnStep == 1"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/tcqn1.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 1,
                            expression: "tcqnStep == 1"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.tcqnStep = 2
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 2 && !_vm.mouseFocus,
                          expression: "tcqnStep == 2 && !mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/tcqn2.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 2 && _vm.mouseFocus,
                          expression: "tcqnStep == 2 && mouseFocus"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/tcqn3.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 2,
                            expression: "tcqnStep == 2"
                          }
                        ],
                        staticClass: "btn2",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocus = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocus = false
                          },
                          click: function($event) {
                            _vm.tcqnStep = 3
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 3,
                          expression: "tcqnStep == 3"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/tcqn4.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 3,
                            expression: "tcqnStep == 3"
                          }
                        ],
                        staticClass: "btn3",
                        on: {
                          click: function($event) {
                            _vm.tcqnStep = 4
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 4,
                          expression: "tcqnStep == 4"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/tcqn5.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 4,
                            expression: "tcqnStep == 4"
                          }
                        ],
                        staticClass: "btn1",
                        on: {
                          click: function($event) {
                            _vm.tcqnStep = 5
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 5 && !_vm.mouseFocusFZ,
                          expression: "tcqnStep == 5 && !mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/tcqn6.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 5 && _vm.mouseFocusFZ,
                          expression: "tcqnStep == 5 && mouseFocusFZ"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/tcqn7.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 5,
                            expression: "tcqnStep == 5"
                          }
                        ],
                        staticClass: "btn4",
                        on: {
                          mouseenter: function($event) {
                            _vm.mouseFocusFZ = true
                          },
                          mouseleave: function($event) {
                            _vm.mouseFocusFZ = false
                          },
                          click: function($event) {
                            _vm.tcqnStep = 6
                          }
                        }
                      },
                      [_vm._v(" ")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tcqnStep == 6,
                          expression: "tcqnStep == 6"
                        }
                      ],
                      staticClass: "img-base",
                      attrs: {
                        src: require("@/assets/images/newestqianniu/tcqn8.png")
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tcqnStep == 6,
                            expression: "tcqnStep == 6"
                          }
                        ],
                        staticClass: "btn5",
                        on: { click: _vm.eightStepEnd }
                      },
                      [_vm._v(" ")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(20)
              ]
            ),
            _vm._v(" "),
            _vm.OnInline == "false"
              ? _c(
                  "div",
                  { staticClass: "stoptip", attrs: { id: "studytip-eight" } },
                  [
                    _c(
                      "div",
                      { staticClass: "tip", staticStyle: { width: "290px" } },
                      [
                        _c("span", { staticClass: "el-icon-success" }),
                        _vm._v(" "),
                        _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [
                                _vm._v(
                                  "\n                                你已完成\n                                "
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.myExamNum))
                                ]),
                                _vm._v(
                                  "\n                                次，需完成\n                                "
                                ),
                                _c("b", { staticStyle: { color: "#66B1FF" } }, [
                                  _vm._v(_vm._s(_vm.examNum))
                                ]),
                                _vm._v(
                                  "\n                                次\n                            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "5px" } },
                              [_vm._v("你已完成千牛模拟实操")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.examNum || _vm.myExamNum >= _vm.examNum
                          ? _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: {
                                  width: "160px",
                                  "margin-top": "5px"
                                },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("返回")]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "startstudy",
                                staticStyle: { width: "160px" },
                                on: { click: _vm.goExam }
                              },
                              [_vm._v("继续学习")]
                            )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("1、登录千牛")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("2、基础设置（上）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("3、基础设置（下）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("4、会话窗口常用功能")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("5、智能客服插件（上）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("6、智能客服插件（下）")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six1" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("7、添加其他插件")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("8、售后客服常用功能")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-eight" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("9、退出千牛")])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "normal" } }, [
        _vm._v("账号：淘金云客服:小淘")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "normal" } }, [
        _vm._v("密码：Tj1234")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("验证码为：660220")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("获取短信校验码")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "normal" } }, [
        _vm._v("进入接待中心")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请"),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("新增一条")
      ]),
      _vm._v("快捷短语。短语内容："),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("亲，欢迎光临，请问有什么可以帮您的？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("快捷编码："),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("欢迎")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("分组："),
      _c("span", { staticStyle: { color: "red", "font-weight": "bold" } }, [
        _vm._v("开头语")
      ]),
      _vm._v("（需要自己新增分组）")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请"),
      _c("span", { staticClass: "red-span" }, [_vm._v("先下载")]),
      _vm._v("快捷短语表格"),
      _c("span", { staticClass: "red-span" }, [_vm._v("并保存到桌面上")]),
      _vm._v("，再"),
      _c("span", { staticClass: "red-span" }, [_vm._v("导入")]),
      _vm._v("快捷短语。")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用"),
      _c("span", { staticClass: "red-span" }, [_vm._v("鼠标左键")]),
      _vm._v("点击快捷短语的方式，选择"),
      _c("span", { staticClass: "red-span" }, [_vm._v("并发送")]),
      _vm._v("快捷短语："),
      _c("span", { staticClass: "red-span" }, [
        _vm._v("亲，欢迎光临，请问有什么可以帮您的？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("请采用"),
      _c("span", { staticClass: "red-span" }, [_vm._v("/+快捷编码")]),
      _vm._v("点击快捷短语的方式，选择"),
      _c("span", { staticClass: "red-span" }, [_vm._v("并发送")]),
      _vm._v("快捷短语："),
      _c("span", { staticClass: "red-span" }, [
        _vm._v("亲，欢迎光临，请问有什么可以帮您的？")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n                            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("span", { staticClass: "line" }),
      _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-right" }, [
      _c("h3", [
        _c("span", { staticClass: "line" }),
        _vm._v("\n\t\t\t\t\t\t\t\t提示\n\t\t\t\t\t\t\t")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("请将状态切换为"),
        _c("span", { staticClass: "red-span" }, [_vm._v("挂起，再退出千牛")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2926230f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2926230f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/qianniuExam.vue
// module id = 1701
// module chunks = 0